import type {
  TH2HDiscrepancyReason,
  TH2HPaymentWorkflowStatus,
} from '../store/types';

export const h2hWorkflowStatusTitles: Record<TH2HPaymentWorkflowStatus, string> = {
  awaiting_payment: 'Ожидается оплата / чек',
  requires_action: 'Требует действия',
  awaiting_provider: 'Клиенту зачислено, ожидается AvePay',
  ready_to_settle: 'Готов к завершению',
  discrepancy: 'Расхождение, требуется проверка',
  completed: 'Завершён',
  rejected: 'Отклонён',
};

export const h2hWorkflowStatusColors: Record<TH2HPaymentWorkflowStatus, string> = {
  awaiting_payment: 'gray',
  requires_action: 'orange',
  awaiting_provider: 'blue',
  ready_to_settle: 'cyan',
  discrepancy: 'red',
  completed: 'green',
  rejected: 'gray',
};

export const h2hDiscrepancyReasonTitles: Record<TH2HDiscrepancyReason, string> = {
  provider_callback_conflict: 'Противоречивые callback AvePay',
  provider_currency_mismatch: 'Не совпала валюта callback AvePay',
  invalid_provider_amount: 'Некорректная сумма callback AvePay',
  provider_rejected_after_client_credit: 'AvePay отклонил после зачисления клиенту',
  provider_callback_timeout: 'Истёк срок ожидания callback AvePay',
  provider_completed_after_operator_rejection: 'AvePay подтвердил после отклонения оператором',
  provider_completed_after_expiry: 'AvePay подтвердил после истечения заявки',
  legacy_provider_completed_after_decline: 'AvePay подтвердил после старого отклонения',
};

export const h2hProviderStatusTitles: Record<string, string> = {
  COMPLETED: 'Успешно',
  DECLINED: 'Отклонён',
  CANCELLED: 'Отменён',
};

export const h2hMerchantCallbackStatusTitles = {
  not_sent: 'Не отправлен',
  success: 'Успешно',
  failed: 'Ошибка',
};

const h2hPaymentSystemTitles: Record<string, string> = {
  avepay: 'AvePay',
  paycos: 'Paycos',
  income: 'Income',
  bknpay: 'Bknpay',
  repay: 'Repay',
  '24PayBase': '24PayBase',
};

export const getH2HPaymentSystemTitle = (paymentSystemName: string | null) => (
  paymentSystemName ? h2hPaymentSystemTitles[paymentSystemName] ?? paymentSystemName : 'провайдера'
);

export const formatAge = (seconds: number) => {
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} мин`;

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  return `${hours} ч ${remainingMinutes} мин`;
};
